<template>
  <div>
    <span v-if="label" class="radio-group-label">{{ label }}</span>
    <v-radio-group
      class="radio-group"
      v-model="selectedValue"
      row
      dense
      hide-details
      :readonly="readonly">
      <v-radio v-for="option in options" 
        :key="option.value"
        :disabled="readonly"
        :label="option.label" 
        :value="option.value"
        :style="labelStyle"
        class="radio-option">
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>
  export default {
    name: 'ResRadioGroup',
    props: {
      label: {
        required: false
      },
      value: {
        required: true
      },
      options: {
        type: Array,
        required: true
      },
      readonly: {},
      labelColor: {
        type: String,
        default: 'black'
      }
    },
    computed: {
      selectedValue: {
        get () {
          return this.value
        },
        set(newValue) {
          this.$emit("input", newValue)
        }
      },
      labelStyle() {
        return `color: ${this.readOnly ? 'gray' : this.labelColor};`;
      }
    }
  }
</script>

<style lang="scss" scoped>
.v-input--selection-controls::v-deep {
  margin: 0 !important;
  padding: 0 !important;
}
.radio-group-label {
  display: inline-block; 
  vertical-align: top; 
  padding-right: 8px; 
  padding-top: 1px;
}
.radio-group::v-deep {
  display: inline-block;
  .v-input--selection-controls__input {
    margin-right: 4px;
  }
}
.radio-option::v-deep {
  .v-label   {
    font-size: 13px !important;
    font-weight: bold;
  } 
}
.radio-option:not(.v-radio--is-disabled)::v-deep {
  .v-label   {
    color: inherit !important;
  } 
}
</style>
